const versionPattern =
  /^v?(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-([0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*))?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/

export function isReleaseVersion(value: string): boolean {
  const parts = versionPattern.exec(value)
  return !!parts && !parts[4]?.split('.').some((p) => /^0\d+$/.test(p))
}

/** SemVer precedence, newest first. Build metadata does not affect precedence. */
export function compareReleaseVersions(a: string, b: string): number {
  const av = versionPattern.exec(a)
  const bv = versionPattern.exec(b)
  if (!av || !bv) return a.localeCompare(b)
  for (let i = 1; i <= 3; i++) {
    const delta = Number(bv[i]) - Number(av[i])
    if (delta) return delta
  }
  if (!av[4] || !bv[4]) return av[4] ? 1 : bv[4] ? -1 : 0
  const ap = av[4].split('.'),
    bp = bv[4].split('.')
  for (let i = 0; i < Math.max(ap.length, bp.length); i++) {
    const x = ap[i],
      y = bp[i]
    if (x === y) continue
    if (x === undefined) return 1
    if (y === undefined) return -1
    const xn = /^\d+$/.test(x),
      yn = /^\d+$/.test(y)
    if (xn && yn) return Number(y) - Number(x)
    if (xn !== yn) return xn ? 1 : -1
    return x < y ? 1 : -1
  }
  return 0
}
